import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../../common/html/element'
import { Radio } from '../../../../../../common/html/radio'
import {
  HAS_INDEPENDENT_COMPANY,
  HAS_INDEPENDENT_COMPANY_OPTIONS,
  HAS_PARENT_COMPANY,
  HAS_PARENT_COMPANY_OPTIONS,
  INDICATOR_ID,
} from '../../../../common/constant'
import { changeCriteria, selectCriteria } from '../../../store/slice'

export const RadioGroup = ({ criteriaGroup, screeningIndicatorId }) => {
  const dispatch = useDispatch()

  const data = useSelector(
    selectCriteria([criteriaGroup, screeningIndicatorId, 'data']),
  )

  const config = useMemo(() => {
    switch (screeningIndicatorId) {
      case INDICATOR_ID.HAS_PARENT_COMPANY:
        return {
          options: HAS_PARENT_COMPANY_OPTIONS,
          trueValue: HAS_PARENT_COMPANY.HAS_PARENT,
          falseValue: HAS_PARENT_COMPANY.HAS_NO_PARENT,
        }
      case INDICATOR_ID.HAS_INDEPENDENT_COMPANY:
        return {
          options: HAS_INDEPENDENT_COMPANY_OPTIONS,
          trueValue: HAS_INDEPENDENT_COMPANY.INDEPENDENT_COMPANIES,
          falseValue: HAS_INDEPENDENT_COMPANY.NON_INDEPENDENT_COMPANIES,
        }
      default:
        return null
    }
  }, [screeningIndicatorId])

  const selectedId = useMemo(() => {
    if (data && data.length && config) {
      return !!data[0] ? config.trueValue : config.falseValue
    }
  }, [data, config])

  //Set default data if not exist
  useEffect(() => {
    if (!data) {
      dispatch(
        changeCriteria({
          path: [criteriaGroup, screeningIndicatorId, 'data'],
          data: [true],
        }),
      )
    }
  }, [data])

  const onChange = (value) => {
    if (!config) return
    dispatch(
      changeCriteria({
        path: [criteriaGroup, screeningIndicatorId, 'data'],
        data: value === config.trueValue ? [true] : [false],
      }),
    )
  }

  if (!config) return null

  return (
    <>
      <Element className="dFlex gap2">
        {config.options.map((item) => (
          <Radio
            key={item.id}
            value={item.id}
            title={item.name}
            activeValue={selectedId}
            onChange={onChange}
          />
        ))}
      </Element>
    </>
  )
}
